module.exports = __webpack_public_path__ + "img/subscript.722c9a93.svg";